<div class="spb-step-mongo">
  <div>
    @if (scenario !== 'Omsättning/Villkorsförändring') {
      <div>
        <h3>Nytt lån</h3>
        <mat-form-field subscriptSizing="fixed"
                        [style.width.px]="220">
          <mat-label>Sökt belopp</mat-label>
          <input [formControl]="seekedAmount"
                 matInput
                 name="price"
                 spbFormatNumber>
          @if (seekedAmount.hasError('maxLoanExceeded')) {
            <mat-error>
              Maxbelopp
              {{ seekedAmount.getError('maxLoanExceeded').max | number: '1.0-0':'sv' }}
              kr
              ({{ seekedAmount.getError('maxLoanExceeded').limit | percent }})
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @for (building of buildings; let i = $index; track i) {
      <div class="building-holder">

        <spb-property (changes)="buildingChanges($event)"
                      [building]="building"
                      [seekedAmount]="seekedAmount.value"
                      [scenario]="scenario"/>

        <!-- You cannot remove the base building we are always working with one -->
        <div class="padding-bottom-small">
          @if (i !== 0) {
            <button (click)="removeBuilding(i)" mat-icon-button>
              <mat-icon class="negative">delete</mat-icon>
            </button>
          }
        </div>
      </div>
    }

    <button
        (click)="addBuilding()"
        [style.margin-top.px]="20"
        matButton="filled">Lägg till övrigt boende
    </button>
  </div>

  @if (ngService.parameters$ | async; as parameters) {
    <div class="spb-step-info">
      <p>
        Ange <span class="spb-mongo-highlight">faktisk driftskostnad</span> om
        den överstiger bankens schablon - villa
        {{ parameters.propertyDefaults.VILLA.runCost }}kr,
        bostadsrätt {{ parameters.propertyDefaults.BOSTADSRATT.runCost }}
        kr, fritidshus {{ parameters.propertyDefaults.FRITIDSHUS.runCost }}kr,
        hyresrätt
        {{ parameters.propertyDefaults.HYRES.runCost }}kr
      </p>
      <p><span class="spb-mongo-highlight">Fastighetsavgift</span> beräknas per
        automatik i KALPen baserat på gällande
        regelverk, beräkning sker med högsta
        fastighetsavgift för villa och fritidshus
        (fn. {{ parameters.propertyDefaults.VILLA.yearlyTax | number }} kr /år)
      </p>
      @if (scenario !== scenarioTypes[0]) {
        <p>Om <span
            class="spb-mongo-highlight">Amorteringsgrundande värde</span>
          avviker mot bostadens värde ändrar du till korrekt
          amorteringsgrundande
          värde för
          att få korrekt amorteringskrav senare i rådgivningen.</p>
      }
      @if (scenario !== scenarioTypes[0]) {
        <p>Ange befintlig <span
            class="spb-mongo-highlight">Amorterings- och låneutrymmesgrundande värde om scenariot avser höj</span>.
          Systemet kommer att räkna upp
          denna med sökt belopp för att kontrollera bolånetak och beräkna nytt amorteringskrav. I övriga scenarios anges
          inget belopp i fältet utan detta beräknas som summan av nya och befintliga lån i banken (som inte markerats
          för lösen).</p>
      }
    </div>
  }
</div>
